import { useLocation } from 'react-router-dom';

import { DETAIL_PAGE_ASSET_TYPE, DETAIL_PAGE_RESOURCE, LIST_PAGE_RESOURCE } from './constants';
import type { UseFloatingResourceAddRouteReturn } from './types';

// Resolves the resource type the floating create button should default to for the current
// route. List views match exactly; detail pages match by prefix (they carry an id segment).
// Returns null on routes with no single resource type (e.g. all-data, account), leaving the
// button on its full create menu.
const useFloatingResourceAddRoute = (): UseFloatingResourceAddRouteReturn => {
    const { pathname } = useLocation();

    const listResource = LIST_PAGE_RESOURCE[pathname];

    if (listResource) {
        return { defaultAssetType: null, defaultResource: listResource };
    }

    const detailEntry = Object.entries(DETAIL_PAGE_RESOURCE).find(([prefix]) =>
        pathname.startsWith(prefix)
    );

    const assetTypeEntry = Object.entries(DETAIL_PAGE_ASSET_TYPE).find(([prefix]) =>
        pathname.startsWith(prefix)
    );

    return {
        defaultAssetType: assetTypeEntry?.[1] ?? null,
        defaultResource: detailEntry?.[1] ?? null
    };
};

export default useFloatingResourceAddRoute;
